import React from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { CustomWidthTooltipNoImage } from '../utils/customWidthToolTipUtilNoImage';

export default function SearchBar({ 
    value, 
    onChange, 
    width = 150,
    sx = {}
  }) {
  const handleClear = () => {
    onChange('');
  };

  const toolTip = "Type in any text (or double click a word / phrase) to filter the alerts in the table matching this.";

  return (
    <CustomWidthTooltipNoImage title={ toolTip } placement="top" dynamicWidth="250px" dyanmicHeight="25px" >
        <TextField
          placeholder="Filter"
          variant="filled"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          slotProps={{
            input: {
              endAdornment: value && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear search"
                    onClick={handleClear}
                    edge="end"
                    size="small"
                    sx={{
                      padding: '2px',
                      color: '#666',
                      marginTop: '2px',
                      '&:hover': {
                        color: '#333',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      }
                    }}
                  >
                    <Clear fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          sx={{
            backgroundColor: '#C8C3BC',
            borderRadius: '10px',
            width: `${width}px`,
            '& .MuiFilledInput-root': {
              backgroundColor: '#C8C3BC',
              height: '30px',
              borderRadius: '10px',
              paddingTop: 0,
              paddingBottom: 0,
              alignItems: 'center',
              paddingRight: value ? '4px' : '12px',
            },
            '& .MuiFilledInput-input': {
              padding: '2px 12px 0 12px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
            },
            '& .MuiFilledInput-root:before': {
              display: 'none',
            },
            '& .MuiFilledInput-root:after': {
              display: 'none',
            },
            ...sx
          }}
        />
    </CustomWidthTooltipNoImage>
  )
}
